var map = {
	"./a-gradient.svg": 19220,
	"./a-white.svg": 29699,
	"./academic.svg": 28575,
	"./ask_profile_locked.svg": 32320,
	"./bg-research_group.svg": 57859,
	"./bg-user-verified.jpg": 79516,
	"./centre.svg": 91171,
	"./close-white.svg": 10086,
	"./community.svg": 65285,
	"./dashboard.svg": 79646,
	"./desk-open.svg": 60566,
	"./email.svg": 90554,
	"./empty-page.svg": 24431,
	"./enago.png": 84526,
	"./google-drive.png": 10002,
	"./group-illustration.svg": 89130,
	"./icon/affiliation_at_time_of_writing.svg": 85343,
	"./icon/compare_list.svg": 31656,
	"./icon/incubator.svg": 60921,
	"./icon/network.svg": 69234,
	"./icon/notifications.svg": 28884,
	"./icon/open_access.svg": 27977,
	"./landscape/landscape_list.svg": 68614,
	"./landscape/landscape_us_states.svg": 93751,
	"./landscape/landscape_world.svg": 76910,
	"./lightbulb.svg": 90367,
	"./login.svg": 5253,
	"./no-results.svg": 79974,
	"./organisation.svg": 31592,
	"./personal.svg": 29694,
	"./professional.svg": 86447,
	"./register.svg": 54185,
	"./research_group-company.svg": 96667,
	"./research_group-team.svg": 94617,
	"./resultcard_graphs_locked.svg": 55642,
	"./resultcard_locked.svg": 87528,
	"./resultlist_locked.svg": 3686,
	"./signup.svg": 53798,
	"./student.svg": 31515,
	"./unverified-shield-red.svg": 81173,
	"./unverified-shield-yellow.svg": 4616,
	"./unverified-shield.svg": 64183,
	"./verified-shield.svg": 27168,
	"./welcome-image.svg": 71938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54280;